import { FunctionComponent as F, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PROTOCOL } from "../../core/router/paths";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DescriptionIcon from '@mui/icons-material/Description';
import Stack from "@mui/material/Stack";
import { usePopupState, bindTrigger } from 'material-ui-popup-state/hooks';
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import ShareProtocolDialog from "./ShareProtocolDialog";
import ProtocolListItemMenu from "./ProtocolListItemMenu";
import DeleteProtocolDialog from "./DeleteProtocolDialog";
import DuplicateProtocolWarningDialog from "./DuplicateProtocolWarningDialog";
import RenameProtocolDialog from "./RenameProtocolDialog";
import { Grid } from "@mui/material";
import TooltipIfTruncated from "./TooltipIfTruncated";
import MoveToFolderDialog from "./MoveToFolderDialog/MoveToFolderDialog";
import RemoveSharedProtocolDialog from "./RemoveSharedProtocolDialog";



interface Props
{
  protocolId: number
  indent?: number
  drawerOpen: boolean
}

interface Params
{
  protocolId?: string
}

const ProtocolListItem: F<Props> = (props: Props) =>
{
  const navigate = useNavigate();
  const selectedProtocolId = Number((useParams() as Params).protocolId)
  const popupState = usePopupState({ variant: 'popover' });
  const protocol = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId));
  const user = useSelector((state: IState) => state.user);

  const [moveToFolderDialog, setMoveToFolderDialog] = useState(false);
  const [removeDialog, setRemoveDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [shareDialog, setShareDialog] = useState(false);
  const [duplicateProtocolWarningDialog, setDuplicateProtocolWarningDialog] = useState(false);
  const [renameProtocolDialog, setRenameProtocolDialog] = useState(false);

  if(!protocol)
    return <></>;

  const text = protocol.userId === user.userId ? protocol.name : protocol.username + "'s " + protocol.name;

  return (
    <>
      <Grid container direction='row' sx={{ cursor: 'pointer', pt: '5px', pb: '5px' }}  >
        <Grid item xs style={{ display: "flex", justifyContent: 'flex-start' }} >
          <Stack
            direction='row'
            onClick={() => navigate(PROTOCOL + "/" + props.protocolId)}
            width={220 - 8 * (props.indent || 0) + 'px'}
            sx={{ alignItems: 'center' }}>
            <DescriptionIcon sx={{ mr: '15px', color: '#757575' }}/>
            {props.drawerOpen ?
              <TooltipIfTruncated
                text={text}
                typographyProps={{
                  variant: 'body2',
                  fontWeight: props.protocolId === selectedProtocolId ? 'bold' : 'regular' }} /> :
              <></>}
          </Stack>
        </Grid>
        <Grid item style={{ display: "flex", justifyContent: 'flex-end' }} {...bindTrigger(popupState)}>
          {props.drawerOpen ? <MoreHorizIcon sx={{ color: '#757575' }}/> : <></>}
        </Grid>
      </Grid>

      <ProtocolListItemMenu
        protocolId={props.protocolId}
        setMoveToFolderDialog={setMoveToFolderDialog}
        setRemoveDialog={setRemoveDialog}
        setDeleteDialog={setDeleteDialog}
        showDuplicateWarningDialog={() => setDuplicateProtocolWarningDialog(true)}
        showRenameDialog={() => setRenameProtocolDialog(true)}
        openShareDialog={() => setShareDialog(true)}
        popupState={popupState}/>

      <MoveToFolderDialog
        open={moveToFolderDialog}
        close={() => setMoveToFolderDialog(false)}
        protocolId={props.protocolId}/>

      <RemoveSharedProtocolDialog
        open={removeDialog}
        close={() => setRemoveDialog(false)}
        protocolId={props.protocolId}/>

      <DeleteProtocolDialog
        open={deleteDialog}
        close={() => setDeleteDialog(false)}
        protocolId={props.protocolId}/>

      <ShareProtocolDialog
        open={shareDialog}
        protocolId={props.protocolId}
        handleClose={() => setShareDialog(false)}/>

      <RenameProtocolDialog
        open={renameProtocolDialog}
        protocolId={props.protocolId}
        close={() => setRenameProtocolDialog(false)}/>

      <DuplicateProtocolWarningDialog
        open={duplicateProtocolWarningDialog}
        protocolId={props.protocolId}
        close={() => setDuplicateProtocolWarningDialog(false)}/>
    </>);
}

export default ProtocolListItem;

